module.exports = __webpack_public_path__ + "img/70.c5ba11a7.png";